import React, {FunctionComponent, useEffect} from 'react'
import styles from './StatisticsPage.module.sass'
import {useRootDispatch, useRootSelector} from '../../../utils/hooks'
import RequestDropdown from '../../data-components/dropdowns/RequestDropdown/RequestDropdown'
import {apiRequests} from '../../../http/config'
import {User} from '../../../responses/users'
import Spacer from '../../etc/Spacer'
import clsx from 'clsx'
import {Classes} from '../../../styles'
import Button from '../../controls/Button/Button'
import DownloadIcon from '../../../../files/download.svg'
import {byProjectActions} from '../../../redux/pages/statistics/byProject'
import {getId} from '../../../utils/entity-utils'
import StatisticsTable from './StatisticsTable/StatisticsTable'
import {isSome} from 'fp-ts/Option'
import {ColumnConfiguration} from './StatisticsTable/configuration'
import {ByProjectData} from '../../../responses/statistics'
//import {toBool} from '../../../utils/utils'
import {flow} from 'fp-ts/function'
import {toServerDate} from '../../../utils/date-utils'
import {fst, snd} from 'fp-ts/Tuple'
import ColumnPicker from './ColumnPicker/ColumnPicker'
import {NonEmptyArray} from 'fp-ts/NonEmptyArray'
import FiltersClearIcon from '../../../../files/filters-clear.svg'
import {Direction} from '../../../responses/refs/refs'
import {RequestStatus} from '../../../responses/response'
import TopBarProgress from 'react-topbar-progress-indicator'
import {isDefinedTuple} from '../../../utils/utils'

const configuration: NonEmptyArray<ColumnConfiguration<ByProjectData>> = [{
    group: '',
    name: '',
    render: data => data.name
}, {
    group: 'Всего',
    name: 'Открыто',
    render: data => data.total.total?.opened ?? 0,
}, {
    group: 'Всего',
    name: 'Закрыто',
    render: data => data.total.total?.closed ?? 0,
}, {
    group: 'Всего',
    name: 'Отменено',
    render: data => data.total.total?.canceled ?? 0,
}, {
    group: 'Тяжелый POSm',
    name: 'Открыто',
    render: data => data.total['tyazhelyy-posm']?.opened ?? 0,
}, {
    group: 'Тяжелый POSm',
    name: 'Закрыто',
    render: data => data.total['tyazhelyy-posm']?.closed ?? 0,
}, {
    group: 'Тяжелый POSm',
    name: 'Отменено',
    render: data => data.total['tyazhelyy-posm']?.canceled ?? 0,
}, {
    group: 'Легкий POSm',
    name: 'Открыто',
    render: data => data.total['karton-cardboard']?.opened ?? 0,
}, {
    group: 'Легкий POSm',
    name: 'Закрыто',
    render: data => data.total['karton-cardboard']?.closed ?? 0,
}, {
    group: 'Легкий POSm',
    name: 'Отменено',
    render: data => data.total['karton-cardboard']?.canceled ?? 0,
}, {
    group: 'Дизайн',
    name: 'Открыто',
    render: data => data.total.dizayn?.opened ?? 0,
}, {
    group: 'Дизайн',
    name: 'Закрыто',
    render: data => data.total.dizayn?.closed ?? 0,
}, {
    group: 'Дизайн',
    name: 'Отменено',
    render: data => data.total.dizayn?.canceled ?? 0,
}, {
    group: 'Остальное',
    name: 'Открыто',
    render: data => data.total.other?.opened ?? 0,
}, {
    group: 'Остальное',
    name: 'Закрыто',
    render: data => data.total.other?.closed ?? 0,
}, {
    group: 'Остальное',
    name: 'Отменено',
    render: data => data.total.other?.canceled ?? 0,
}]

const ProjectTab: FunctionComponent = () => {
    const dispatch = useRootDispatch()
    const {
        data,
        hide,
        open,
        sort,
        users,
        managers,
        directions,
        state
    } = useRootSelector(state => state.pages.statistics.byProject)
    const { brands, clients, date} = useRootSelector(state => state.pages.statistics.byClient)


    useEffect(() => {
        if (isDefinedTuple(date)) {
            dispatch(byProjectActions.data.request({
                managers: managers.map(getId),
                directions: directions.map(getId),
                users: users.map(getId),
                //compare: toBool(periods),
                brands: brands.map(getId),
                clients: clients.map(getId),
                date_from: toServerDate(fst(date)),
                date_to: toServerDate(snd(date)),
            }))
        }
    }, [dispatch, managers, directions, users, brands, clients, date])

    return <div className={styles.content}>
        {
            state === RequestStatus.FETCHING && <TopBarProgress/>
        }
        <div className={styles.header}>
            <RequestDropdown<User>
                className={styles.dropdown}
                placeholder={'Менеджер'}
                type={'multi'}
                value={managers}
                onChange={managers => dispatch(byProjectActions.setManagers(managers))}
                request={query => apiRequests.dictionary.list({
                    params: {key: 'manager'},
                    query
                })}
                render={user => user.name}
            />
            <RequestDropdown<Direction>
                className={styles.dropdown}
                placeholder={'Направление'}
                render={direction => direction.title}
                request={query => apiRequests.dictionary.directionList({
                    query
                })}
                type={'multi'}
                onChange={directions => dispatch(byProjectActions.setDirections(directions))}
                value={directions}
            />
            <Button
                title={'Очистить фильтры'}
                onClick={() => dispatch(byProjectActions.clearFilters())}
            >
                <FiltersClearIcon/>
            </Button>
            <Spacer/>
            <div className={clsx(styles.text, Classes.f9)}>
                <div>Для выгрузки в Excel выберите столбцы,</div>
                <div>Менеджера и соответствующих Исполнителей.</div>
            </div>
            <ColumnPicker hide={hide} config={configuration}
                          onChange={flow(byProjectActions.setHiddenColumns, dispatch)}/>
            <Button title={'Скачать в формате Excel'}>
                <DownloadIcon/>
            </Button>
        </div>
        {
            isSome(data) && <StatisticsTable
                name={'Проект'}
                data={data.value}
                config={configuration}
                hide={hide}
                open={open}
                sort={sort}
                onSortChange={flow(byProjectActions.setSort, dispatch)}
                onRowToggle={flow(byProjectActions.toggleRow, dispatch)}
            />
        }
    </div>
}

export default ProjectTab